import { render, staticRenderFns } from "./DocToCarReport.vue?vue&type=template&id=0023e989&scoped=true&"
import script from "./DocToCarReport.vue?vue&type=script&lang=ts&"
export * from "./DocToCarReport.vue?vue&type=script&lang=ts&"
import style0 from "./doc-to-car-report.scss?vue&type=style&index=0&id=0023e989&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0023e989",
  null
  
)

export default component.exports